module.exports = __webpack_public_path__ + "static/media/DotGrey.9a4b45ee.svg";